import Index from './index.vue'
import Adware from '@/modules/masjidAd/components/Adware.vue'
// import Logout from './components/Logout.vue'

export default [
  {
    path: '/adware',
    name: 'adware',
    component: Index,
    title: 'adweare',
    children: [
      {
        path: '/',
        name: 'adweare-view',
        component: Adware,
        props: true,
      },
    ],
  },
]
